import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { NoPlacementDummy } from '../Dummy';
import { PageValidatorPreloader } from './PageValidatorPreloader';
var PageValidator = function (_a) {
    var children = _a.children, groupInfo = _a.groupInfo, groupInfoLoading = _a.groupInfoLoading;
    if (!groupInfo || groupInfoLoading)
        return _jsx(PageValidatorPreloader, {}, void 0);
    if (!groupInfo.placementCompleted && !groupInfo.skipAssessments)
        return _jsx(NoPlacementDummy, {}, void 0);
    return _jsx(_Fragment, { children: children }, void 0);
};
export { PageValidator };
